// extracted by mini-css-extract-plugin
export default {"filters":"FiltersBlock_filters__skjle","filters_close":"FiltersBlock_filters_close__TQf9L"};